import React from 'react';
import * as Icons from 'lucide-react';
import { whyUs, heroImages } from '../mock';

const cardStyles = [
  { bg: 'linear-gradient(135deg, #1F8B4C 0%, #26A45A 100%)', text: '#fff', iconBg: 'rgba(255,255,255,0.2)', iconColor: '#fff', sub: 'rgba(255,255,255,0.85)' },
  { bg: 'linear-gradient(135deg, #FFF7EE 0%, #FFE9CF 100%)', text: '#0f2b1d', iconBg: '#FF7A00', iconColor: '#fff', sub: '#4a5a52' },
  { bg: 'linear-gradient(135deg, #FF7A00 0%, #FFA236 100%)', text: '#fff', iconBg: 'rgba(255,255,255,0.22)', iconColor: '#fff', sub: 'rgba(255,255,255,0.9)' },
  { bg: 'linear-gradient(135deg, #E8F5EE 0%, #CDEBD8 100%)', text: '#0f2b1d', iconBg: '#1F8B4C', iconColor: '#fff', sub: '#4a5a52' },
  { bg: 'linear-gradient(135deg, #146638 0%, #1F8B4C 100%)', text: '#fff', iconBg: 'rgba(255,255,255,0.2)', iconColor: '#FFB629', sub: 'rgba(255,255,255,0.85)' },
  { bg: 'linear-gradient(135deg, #FFF3D6 0%, #FFE1A0 100%)', text: '#0f2b1d', iconBg: '#FFB629', iconColor: '#fff', sub: '#4a5a52' },
];

export default function WhyUs() {
  return (
    <section id="about" className="section bg-white">
      <div className="container-x grid lg:grid-cols-2 gap-12 items-center mb-20">
        <div className="relative">
          <img
            src={heroImages.team}
            alt="team collaboration"
            className="rounded-3xl w-full h-[420px] object-cover shadow-2xl border-4 border-white"
          />
          <img
            src={heroImages.warehouse}
            alt="warehouse"
            className="hidden md:block absolute -bottom-10 -left-10 w-48 h-48 object-cover rounded-2xl border-4 border-white shadow-xl"
          />
          <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-5 border border-neutral-100 hidden md:block">
            <div className="text-3xl font-black text-[color:var(--brand-green)]">30,000+</div>
            <div className="text-xs font-semibold text-[color:var(--ink-soft)] uppercase tracking-wide">
              Trusted Merchants
            </div>
          </div>
        </div>

        <div>
          <div className="eyebrow">About Us</div>
          <h2 className="section-title mt-3">
            Because Your Great Product Deserves the <span className="grad-text">Spotlight</span>
          </h2>
          <p className="section-sub mt-5">
            EC SAFETRADE SOLUTIONS is a full-service digital growth partner. From setting up your
            seller central to scaling your brand across 8+ marketplaces, social platforms, and
            your own website — we handle it end-to-end.
          </p>
          <p className="section-sub mt-4">
            Our team of marketplace experts, designers and marketers use proven playbooks to boost
            visibility, conversions and revenue — while you focus on what you do best: your
            product.
          </p>

          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="bg-[color:var(--brand-green-light)] rounded-xl p-4 border border-[color:var(--brand-green)]/20">
              <div className="text-2xl font-black text-[color:var(--brand-green)]">10+</div>
              <div className="text-xs text-[color:var(--ink-soft)] font-semibold uppercase">Years Experience</div>
            </div>
            <div className="bg-orange-50 rounded-xl p-4 border border-[color:var(--brand-orange)]/20">
              <div className="text-2xl font-black text-[color:var(--brand-orange)]">50+</div>
              <div className="text-xs text-[color:var(--ink-soft)] font-semibold uppercase">Experts on Team</div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-x">
        <div className="text-center mb-12">
          <div className="eyebrow">Why choose us</div>
          <h2 className="section-title mt-3">Why You Need Our Ecommerce Services</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyUs.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Sparkles;
            const s = cardStyles[i % cardStyles.length];
            return (
              <div
                key={w.title}
                className="card-hover rounded-2xl p-7 shadow-md relative overflow-hidden"
                style={{ background: s.bg, color: s.text }}
              >
                <div
                  className="absolute -right-6 -bottom-6 w-24 h-24 rounded-full opacity-20"
                  style={{ background: s.iconColor }}
                />
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 shadow-md"
                  style={{ background: s.iconBg, color: s.iconColor }}
                >
                  <Icon size={26} />
                </div>
                <h3 className="font-bold text-lg mb-2" style={{ color: s.text }}>
                  {w.title}
                </h3>
                <p className="text-sm leading-relaxed relative z-10" style={{ color: s.sub }}>
                  {w.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
